"use client"
import styles from "./ActionLogsModal.module.css"

const ActionLogsModal = ({ shift, onClose }) => {
  const formatTimestamp = (timestamp) => {
    // Handle null or undefined timestamp
    if (!timestamp) return 'N/A';
    
    // Convert timestamp to string safely
    const timestampStr = String(timestamp);
    
    // Check if timestamp is in milliseconds (13 digits)
    const date = timestampStr.length === 13 
      ? new Date(parseInt(timestamp, 10)) 
      : new Date(timestamp * 1000); // Convert seconds to milliseconds if needed
    
    if (isNaN(date.getTime())) {
      console.error('Invalid date:', timestamp);
      return 'N/A';
    }
  
    return date.toLocaleString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  }
//   console.log("shiftsssssss>>>", shift.approvedAt);
//   console.log(formatTimestamp(1754894023437)); // Will work with millisecond timestamp
// console.log(formatTimestamp(1754894023));    // Will also work with second timestamp

  const getLogIcon = (status) => {
    switch (status) {
      case "APPROVED":
        return "✓"
      case "RESOLVED":
        return "✓"
      case "DISPUTED":
        return "!"
      case "PENDING_APPROVAL":
        return "⏳"
      default:
        return "•"
    }
  }

  const getLogClass = (status) => {
    switch (status) {
      case "APPROVED":
          return "logSuccess"
      case "RESOLVED":
        return "logSuccess"
      case "DISPUTED":
        return "logWarning"
      case "PENDING_APPROVAL":
        return "logPending"
      default:
        return "logDefault"
    }
  }

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }
console.log("shiftsss>>>", shift);

  return (
    <div className={styles.modalOverlay} onClick={handleOverlayClick}>
      <div className={styles.logsModal}>
        <div className={styles.modalHeader}>
          <h2>Action Logs</h2>
          <button className={styles.closeBtn} onClick={onClose}>
            ×
          </button>
        </div>

        <div className={styles.modalBody}>
          {/* <div className={styles.shiftInfo}>
            <h3>
              {shift?.id} - {shift?.specialization}
            </h3>
            <div className={styles.shiftDetails}>
              <span>Professional: {shift?.professionalName}</span>
              <span>Start: {shift?.shiftStartDateTime}</span>
              <span>End: {shift?.shiftEndDateTime}</span>
              <span>Cost: {shift?.totalCost}</span>
              <span className={`${styles.statusBadge} ${styles[`status${shift?.status}`]}`}>{shift?.status}</span>
            </div>
          </div> */}

          <div className={styles.logsSection}>
            <h4>Timeline</h4>
            {shift.status === "DISPUTED" || shift.status === "RESOLVED" ? (
              <div className={styles.logsTimeline}>
                {/* {shift?.status?.map((log, index) => ( */}
                <div className={`${styles.logEntry} ${styles.logWarning}`}>
                  <div className={styles.logIcon}>!</div>
                  <div className={styles.logContent}>
                    <div className={styles.logAction}>
                      {shift.status === "DISPUTED" ||
                      shift.status === "RESOLVED"
                        ? `Dispute Raised - ${
                            shift?.disputedReason == "Others" || 
                            shift?.disputedReason == "Other"
                              ? "Others (" + shift?.disputedComment + ")"
                              : shift?.disputedReason
                          }`
                        : null}
                    </div>
                    <div className={styles.logTimestamp}>
                      {formatTimestamp(shift?.disputedCreatedAt)}
                    </div>
                  </div>
                </div>
                {/* ))} */}
              </div>
            ) : null}

            {shift.status === "APPROVED" || shift.status === "RESOLVED" ? (
              <div className={styles.logsTimeline}>
                {/* {shift?.status?.map((log, index) => ( */}
                <div
                  className={`${styles.logEntry} ${
                    styles[getLogClass(shift.status)]
                  }`}
                >
                  <div className={styles.logIcon}>
                    {getLogIcon(shift.status)}
                  </div>
                  <div className={styles.logContent}>
                    <div className={styles.logAction}>
                      {shift.status === "APPROVED" ||
                      shift.status === "RESOLVED"
                        ? "Approved"
                        : null}
                    </div>
                    <div className={styles.logTimestamp}>
                      {formatTimestamp(
                        shift.status === "RESOLVED"
                          ? shift.resolvedApprovedAt
                          : shift.approvedAt
                      )}
                    </div>
                  </div>
                </div>
                {/* ))} */}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ActionLogsModal
